// infcode_change - new file
export const METRICS_APP_NAME = "InfCode"

export type MetricsPlatform = "cli" | "vscode" | "jetbrains" | "ide"

export function resolveMetricsPlatform(
  env: Record<string, string | undefined> = process.env,
): MetricsPlatform {
  const platform = env["INFCODE_PLATFORM"]
  if (platform === "vscode" || platform === "jetbrains" || platform === "ide") return platform
  return "cli"
}

export function resolveMetricsOs(nodePlatform: string = process.platform) {
  const platform = nodePlatform.trim()
  if (platform === "win32") return "win32"
  if (platform === "darwin") return "macos"
  if (platform === "linux") return "linux"
  return platform ? "other" : "unknown"
}
